<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title class="header-title2">{{ $t("term_of_use") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text v-html="$store.state.termsOfUseContent" class="content"> </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    //content: "",
  }),

  created() {
/*     this.content = "";
    if (this.$store.state.termsOfUseUrl != null && this.$store.state.termsOfUseUrl != "") {
    fetch(this.$store.state.termsOfUseUrl)
      .then((response) => {
        response.text().then((result) => {
          this.content = result;
          //console.log(result);
        });
      })
      .catch((error) => {
        console.log(error);
      });
    } */
  },

  computed: {},

  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 12px 12px !important;
  color: black !important;
}
</style>
